<template>
  <div class="supplierServiceInformation">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      :ellipsis="false"
      swipeable
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList(page + 1)"
        >
          <div
            class="list-container"
            v-for="(item, index) in tableData"
            :key="index"
            @click="gotoDetail(item.SIRId)"
          >
            <div class="list-item">Vtrack Id：{{ item.UserNumber }}</div>
            <div class="list-item">
              {{ $t.supplier.companyName }}：{{ item.CompanyName }}
            </div>
            <div class="list-item">
              {{ $t.supplier.contactName }}：{{ item.UserName }}
            </div>
            <div class="list-item">
              {{ $t.supplier.phoneNumber }}：{{ item.PhoneNumber }}
            </div>
            <div class="list-item">{{ $t.supplier.wechat }}：{{ item.WechatNumber }}</div>
            <div class="list-item">
              {{ $t.supplier.referrer }}：{{ item.SharerUserName }}
            </div>
            <div class="list-item">
              {{ $t.supplier.lastDate }}：{{ item.InfoLastUpdateDate }}
            </div>
            <template v-if="menuState == 4">
              <div class="list-item">
                {{ $t.supplier.cooperate }}：{{ item.CooperateCount }}
              </div>
              <div class="list-item">
                {{ $t.supplier.serviceCate }}：{{ item.ServiceCategory }}
              </div>
              <div class="list-item">
                {{ $t.supplier.businessClass }}：{{ item.BusinessClassification }}
              </div>
              <div class="list-item">
                {{ $t.supplier.serviceCountry }}：{{ item.ServiceCountry }}
              </div>
              <div class="list-item">
                {{ $t.supplier.serviceArea }}：{{ item.ServiceArea }}
              </div>
              <div class="list-item">
                {{ $t.supplier.serviceContent }}：{{ item.ServiceContent }}
              </div>
              <div class="list-item">
                {{ $t.supplier.serviceDetail }}：{{ item.ServiceContentDetail }}
              </div>
              <div class="list-item">
                {{ $t.supplier.operatingProducts }}：{{ item.OperatingProducts }}
              </div>
            </template>
            <template v-if="menuState == 3">
              <div class="list-item">
                {{ $t.supplier.cooperate }}：{{ item.CooperateCount }}
              </div>
              <div class="list-item">
                {{ $t.supplier.serviceArea }}：{{ item.ServiceArea }}
              </div>
              <div class="list-item">
                {{ $t.supplier.regulatory }}：{{ item.RegulatoryCategory }}
              </div>
              <div class="list-item">
                {{ $t.supplier.warehouseCate }}：{{ item.WarehouseCategory }}
              </div>
              <div class="list-item">{{ $t.supplier.country }}：{{ item.Country }}</div>
              <div class="list-item">
                {{ $t.supplier.danger }}：{{ item.DangerousGoodsRegistration }}
              </div>
            </template>
            <template v-if="menuState == 2">
              <div class="list-item">
                {{ $t.supplier.vehicleNum }}：{{ item.VehiclesNum }}
              </div>
              <div class="list-item">
                {{ $t.supplier.cooperate }}：{{ item.CooperateCount }}
              </div>
              <div class="list-item">
                {{ $t.supplier.serviceArea }}：{{ item.ServiceArea }}
              </div>
              <div class="list-item">
                {{ $t.supplier.vehicleCate }}：{{ item.VehicleCategory }}
              </div>
              <div class="list-item">
                {{ $t.supplier.vehicleType }}：{{ item.VehicleType }}
              </div>
            </template>
            <template v-if="menuState == 1">
              <div class="list-item">{{ $t.supplier.carrier }}：{{ item.Carrier }}</div>
              <div class="list-item">
                {{ $t.supplier.cooperate }}：{{ item.CooperateCount }}
              </div>
              <div class="list-item">
                {{ $t.supplier.mainBusiness }}：{{ item.MainBusiness }}
              </div>
              <div class="list-item">
                {{ $t.supplier.exportCate }}：{{ item.ImportExportCategory }}
              </div>
              <div class="list-item">
                {{ $t.supplier.businessClass }}：{{ item.BusinessClassification }}
              </div>
            </template>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div v-if="menuState == 1">
          <div class="radio-label">{{ $t.supplier.mainBusiness }}</div>
          <van-radio-group v-model="mainBusiness" direction="horizontal">
            <van-radio :name="1">{{ $t.supplier.wbType1 }}</van-radio>
            <van-radio :name="2">{{ $t.supplier.wbType2 }}</van-radio>
            <van-radio :name="3">{{ $t.supplier.wbType3 }}</van-radio>
            <van-radio :name="4">{{ $t.supplier.wbType4 }}</van-radio>
          </van-radio-group>

          <div class="radio-label">{{ $t.supplier.exportCate }}</div>
          <van-radio-group v-model="importExportCategory" direction="horizontal">
            <van-radio :name="1">{{ $t.supplier.export1 }}</van-radio>
            <van-radio :name="2">{{ $t.supplier.export2 }}</van-radio>
          </van-radio-group>

          <div class="radio-label">{{ $t.supplier.businessClass }}</div>
          <van-radio-group v-model="businessClassification" direction="horizontal">
            <van-radio :name="1">{{ $t.supplier.business1 }}</van-radio>
            <van-radio :name="2">{{ $t.supplier.business2 }}</van-radio>
            <van-radio :name="3">{{ $t.supplier.business3 }}</van-radio>
            <van-radio :name="4">{{ $t.supplier.business4 }}</van-radio>
            <van-radio :name="5">{{ $t.supplier.business5 }}</van-radio>
          </van-radio-group>
        </div>

        <div v-if="menuState == 2">
          <div class="radio-label">{{ $t.supplier.serviceArea }}</div>
          <van-radio-group v-model="serviceArea" direction="horizontal">
            <van-radio :name="1">{{ $t.supplier.area1 }}</van-radio>
            <van-radio :name="2">{{ $t.supplier.area2 }}</van-radio>
            <van-radio :name="3">{{ $t.supplier.area3 }}</van-radio>
            <van-radio :name="4">{{ $t.supplier.area4 }}</van-radio>
            <van-radio :name="5">{{ $t.supplier.area5 }}</van-radio>
          </van-radio-group>

          <div class="radio-label">{{ $t.supplier.vehicleCate }}</div>
          <van-radio-group v-model="vehicleCategory" direction="horizontal">
            <van-radio :name="1">{{ $t.supplier.car1 }}</van-radio>
            <van-radio :name="2">{{ $t.supplier.car2 }}</van-radio>
            <van-radio :name="3">{{ $t.supplier.car3 }}</van-radio>
            <van-radio :name="4">{{ $t.supplier.car4 }}</van-radio>
          </van-radio-group>

          <div class="radio-label">{{ $t.supplier.vehicleCate }}</div>
          <van-radio-group v-model="vehicleType" direction="horizontal">
            <van-radio :name="1">{{ $t.supplier.weight1 }}</van-radio>
            <van-radio :name="2">{{ $t.supplier.weight2 }}</van-radio>
            <van-radio :name="3">{{ $t.supplier.weight3 }}</van-radio>
            <van-radio :name="4">{{ $t.supplier.weight4 }}</van-radio>
            <van-radio :name="5">{{ $t.supplier.weight5 }}</van-radio>
            <van-radio :name="6">{{ $t.supplier.weight6 }}</van-radio>
            <van-radio :name="7">{{ $t.supplier.weight7 }}</van-radio>
            <van-radio :name="8">{{ $t.supplier.weight8 }}</van-radio>
            <van-radio :name="9">{{ $t.supplier.weight9 }}</van-radio>
          </van-radio-group>
        </div>

        <div v-if="menuState == 3">
          <div class="radio-label">{{ $t.supplier.serviceArea }}</div>
          <van-radio-group v-model="serviceArea" direction="horizontal">
            <van-radio :name="1">{{ $t.supplier.serveWarehouse1 }}</van-radio>
            <van-radio :name="2">{{ $t.supplier.serveWarehouse2 }}</van-radio>
            <van-radio :name="3">{{ $t.supplier.serveWarehouse3 }}</van-radio>
          </van-radio-group>

          <div class="radio-label">{{ $t.supplier.regulatory }}</div>
          <van-radio-group v-model="regulatoryCategory" direction="horizontal">
            <van-radio :name="1">{{ $t.supplier.superviseWarehouse1 }}</van-radio>
            <van-radio :name="2">{{ $t.supplier.superviseWarehouse2 }}</van-radio>
            <van-radio :name="3">{{ $t.supplier.superviseWarehouse3 }}</van-radio>
            <van-radio :name="4">{{ $t.supplier.superviseWarehouse4 }}</van-radio>
          </van-radio-group>

          <div class="radio-label">{{ $t.supplier.warehouseCate }}</div>
          <van-radio-group v-model="warehouseCategory" direction="horizontal">
            <van-radio :name="1">{{ $t.supplier.typeWarehouse1 }}</van-radio>
            <van-radio :name="2">{{ $t.supplier.typeWarehouse2 }}</van-radio>
            <van-radio :name="3">{{ $t.supplier.typeWarehouse3 }}</van-radio>
            <van-radio :name="4">{{ $t.supplier.typeWarehouse4 }}</van-radio>
            <van-radio :name="5">{{ $t.supplier.typeWarehouse5 }}</van-radio>
            <van-radio :name="6">{{ $t.supplier.typeWarehouse6 }}</van-radio>
            <van-radio :name="7">{{ $t.supplier.typeWarehouse7 }}</van-radio>
            <van-radio :name="8">{{ $t.supplier.typeWarehouse8 }}</van-radio>
            <van-radio :name="9">{{ $t.supplier.typeWarehouse9 }}</van-radio>
          </van-radio-group>
        </div>

        <div v-if="menuState == 4">
          <div class="radio-label">{{ $t.supplier.serviceCate }}</div>
          <van-radio-group v-model="serviceCategory" direction="horizontal">
            <van-radio :name="1">{{ $t.supplier.service1 }}</van-radio>
            <van-radio :name="2">{{ $t.supplier.service2 }}</van-radio>
            <van-radio :name="3">{{ $t.supplier.service3 }}</van-radio>
            <van-radio :name="4">{{ $t.supplier.service4 }}</van-radio>
            <van-radio :name="5">{{ $t.supplier.service5 }}</van-radio>
            <van-radio :name="6">{{ $t.supplier.service6 }}</van-radio>
            <van-radio :name="7">{{ $t.supplier.service7 }}</van-radio>
          </van-radio-group>
        </div>

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  DatetimePicker,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup)
  .use(Tab)
  .use(Tabs);

export default {
  name: "supplierServiceInformation",
  data() {
    return {
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.supplier.tab1,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.supplier.tab2,
          name: 2,
          count: 0,
        },
        {
          title: this.$t.supplier.tab3,
          name: 3,
          count: 0,
        },
        {
          title: this.$t.supplier.tab4,
          name: 4,
          count: 0,
        },
      ],
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: "Vtrack Id",
          value: 1,
        },
        {
          text: this.$t.supplier.referrer,
          value: 2,
        },
        {
          text: this.$t.supplier.companyName,
          value: 3,
        },
        {
          text: this.$t.supplier.carrier,
          value: 4,
        },
      ],
      //1
      mainBusiness: null,
      importExportCategory: null,
      businessClassification: null,
      //2
      serviceArea: null,
      vehicleCategory: null,
      vehicleType: null,
      //3
      regulatoryCategory: null,
      warehouseCategory: null,
      //4
      serviceCategory: null,
      showFilter: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList(1);
    },
  },
  created() {},
  methods: {
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "answerDetail",
        name: "answerDetail",
        query: [
          {
            name: "SIRId",
            value: id,
          },
        ],
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (
        this.mainBusiness ||
        this.importExportCategory ||
        this.businessClassification ||
        this.serviceArea ||
        this.vehicleCategory ||
        this.vehicleType ||
        this.regulatoryCategory ||
        this.warehouseCategory ||
        this.serviceCategory ||
        (this.beginTime && this.endTime)
      ) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.mainBusiness = null;
      this.importExportCategory = null;
      this.businessClassification = null;
      this.serviceArea = null;
      this.vehicleCategory = null;
      this.vehicleType = null;
      this.regulatoryCategory = null;
      this.warehouseCategory = null;
      this.serviceCategory = null;
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
      this.searchText = "";
      this.searchType = 1;
      if (this.menuState == 1) {
        this.searchTypeOptions = [
          {
            text: "Vtrack Id",
            value: 1,
          },
          {
            text: this.$t.supplier.referrer,
            value: 2,
          },
          {
            text: this.$t.supplier.companyName,
            value: 3,
          },
          {
            text: this.$t.supplier.carrier,
            value: 4,
          },
        ];
      } else {
        this.searchTypeOptions = [
          {
            text: "Vtrack Id",
            value: 1,
          },
          {
            text: this.$t.supplier.referrer,
            value: 2,
          },
          {
            text: this.$t.supplier.companyName,
            value: 3,
          },
        ];
      }
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      var request = null;
      if (this.menuState == 4) {
        param.UserNumber = this.searchType == 1 ? this.searchText : "";
        param.ReferBy = this.searchType == 2 ? this.searchText : "";
        param.CompanyName = this.searchType == 3 ? this.searchText : "";
        param.ServiceCategory = this.serviceCategory;
        request = this.$api.supplier.getSupplierIndustryValueAddedSupportingServiceInfoList(
          param
        );
      } else if (this.menuState == 3) {
        param.UserNumber = this.searchType == 1 ? this.searchText : "";
        param.ReferBy = this.searchType == 2 ? this.searchText : "";
        param.CompanyName = this.searchType == 3 ? this.searchText : "";
        param.ServiceArea = this.serviceArea;
        param.RegulatoryCategory = this.regulatoryCategory;
        param.WarehouseCategory = this.warehouseCategory;
        request = this.$api.supplier.getSupplierWarehousingServiceInfoList(param);
      } else if (this.menuState == 2) {
        param.UserNumber = this.searchType == 1 ? this.searchText : "";
        param.ReferBy = this.searchType == 2 ? this.searchText : "";
        param.CompanyName = this.searchType == 3 ? this.searchText : "";
        param.ServiceArea = this.serviceArea;
        param.VehicleCategory = this.vehicleCategory;
        param.VehicleType = this.vehicleType;
        request = this.$api.supplier.getSupplierAutomobileTransportationServiceInfoList(
          param
        );
      } else {
        param.UserNumber = this.searchType == 1 ? this.searchText : "";
        param.ReferBy = this.searchType == 2 ? this.searchText : "";
        param.CompanyName = this.searchType == 3 ? this.searchText : "";
        param.Carrier = this.searchType == 4 ? this.searchText : "";
        param.MainBusiness = this.mainBusiness;
        param.ImportExportCategory = this.importExportCategory;
        param.BusinessClassification = this.businessClassification;
        request = this.$api.supplier.getSupplierTransportationServiceInfoList(param);
      }
      request
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.supplierServiceInformation {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        padding-bottom: 10px;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
}
</style>
